// Source : frontend/VERSION (lu par vite.config.ts au démarrage)
// Exposé via import.meta.env (mécanisme standard Vite).
export const APP_VERSION: string = import.meta.env.VITE_APP_VERSION ?? '0.0.0-unknown';

